import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ImFacebook2 } from "react-icons/im";
import { MdLeaderboard } from "react-icons/md";
import FaceBookLoginButton from "./FaceBookLoginButton";
import { axiosApiInstance } from "../../app/axios";
import { API_URL } from "../../app/config";
import IconComponent from "../../components/common/IconComponent";

const Integrations: React.FC = () => {
  const navigate = useNavigate();
  const [lgFBToken, setLgFBToken] = useState(localStorage.getItem("FBTOKEN"));
  const [accesstoken, setAccessToken] = useState<any>();

  useEffect(() => {
    const passFBToken = async () => {
      if (accesstoken) {
        const response = await axiosApiInstance.post(
          `${API_URL}/webhook/WebHookToken`,
          {
            WebHookToken: accesstoken,
          }
        );
        if (response.data.Status === 200 && response.data.Data?.WebHookToken) {
          localStorage.setItem(
            "FBTOKEN",
            response.data.Data?.WebHookToken || ""
          );
          setLgFBToken(response.data.Data?.WebHookToken);
        }
      }
    };
    passFBToken();
  }, [accesstoken]);

  return (
    <GridLayout
      style={{ marginRight: 20 }}
      gap={{ cols: 10, rows: 0 }}
      cols={[{ width: "33.33%" }, { width: "33.33%" }, { width: "33.33%" }]}
    >
      <GridLayoutItem
        colSpan={3}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 20px 20px 0",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          FB/Insta Lead Integrations
        </Typography.h4>
      </GridLayoutItem>
      <GridLayoutItem colSpan={3} className="d-flex gap-3">
        {!lgFBToken ? (
          <GridLayout
            style={{ marginRight: 20 }}
            gap={{ cols: 10, rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              Allow Meta access to display your leads in CRM.
            </GridLayoutItem>
            <GridLayoutItem>
              <FaceBookLoginButton setAccessToken={setAccessToken} />
            </GridLayoutItem>
          </GridLayout>
        ) : (
          <>
            <div className="integration-menu-card">
              <div
                className="integration-menu-poster"
                onClick={() => navigate("/integrations/facebook")}
              >
                <IconComponent
                  icon={ImFacebook2}
                  className="integration-menu-icon"
                />
              </div>
              <p className="m-0 text-center">
                Facebook <br />
                Integration
              </p>
            </div>
            <div className="integration-menu-card">
              <div
                className="integration-menu-poster"
                onClick={() => navigate("/integrations/leadcenter")}
              >
                <IconComponent
                  icon={MdLeaderboard}
                  className="integration-menu-icon"
                />
              </div>
              <p className="m-0 text-center">
                Facebook <br />
                Lead Center
              </p>
            </div>
          </>
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

export default Integrations;
